export default "__VITE_ASSET__mIP5exjK__"